// /*================ Shopify Common JS ================*/
// if ((typeof window.Shopify) == 'undefined') {
//   window.Shopify = {};
// }

// Shopify.bind = function(fn, scope) {
//   return function() {
//     return fn.apply(scope, arguments);
//   }
// };

// Shopify.setSelectorByValue = function(selector, value) {
//   for (var i = 0, count = selector.options.length; i < count; i++) {
//     var option = selector.options[i];
//     if (value == option.value || value == option.innerHTML) {
//       selector.selectedIndex = i;
//       return i;
//     }
//   } 
// };

// Shopify.addListener = function(target, eventName, callback) {
//   target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
// };

// Shopify.postLink = function(path, options) {
//   options = options || {};
//   var method = options['method'] || 'post';
//   var params = options['parameters'] || {};

//   var form = document.createElement("form");
//   form.setAttribute("method", method);
//   form.setAttribute("action", path);

//   for(var key in params) {
//     var hiddenField = document.createElement("input");
//     hiddenField.setAttribute("type", "hidden");
//     hiddenField.setAttribute("name", key);
//     hiddenField.setAttribute("value", params[key]);
//     form.appendChild(hiddenField);
//   }
//   document.body.appendChild(form);
//   form.submit();
//   document.body.removeChild(form);
// };

// Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
//   this.countryEl         = document.getElementById(country_domid);
//   this.provinceEl        = document.getElementById(province_domid);
//   this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

//   if (this.countryEl) {
//     Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

//     this.initCountry();
//     this.initProvince();
//   }
// };

// Shopify.CountryProvinceSelector.prototype = {
//   initCountry: function() {
//     var value = this.countryEl.getAttribute('data-default');
//     Shopify.setSelectorByValue(this.countryEl, value);
//     this.countryHandler();
//   },

//   initProvince: function() {
//     var value = this.provinceEl.getAttribute('data-default');
//     if (value && this.provinceEl.options.length > 0) {
//       Shopify.setSelectorByValue(this.provinceEl, value);
//     }
//   },

//   countryHandler: function(e) {
//     var opt       = this.countryEl.options[this.countryEl.selectedIndex];
//     var raw       = opt.getAttribute('data-provinces');
//     var provinces = JSON.parse(raw);

//     this.clearOptions(this.provinceEl);
//     if (provinces && provinces.length == 0) {
//       this.provinceContainer.style.display = 'none';
//     } else {
//       for (var i = 0; i < provinces.length; i++) {
//         var opt = document.createElement('option');
//         opt.value = provinces[i][0];
//         opt.innerHTML = provinces[i][1];
//         this.provinceEl.appendChild(opt);
//       }

//       this.provinceContainer.style.display = "";
//     }
//   },

//   clearOptions: function(selector) {
//     while (selector.firstChild) {
//       selector.removeChild(selector.firstChild);
//     }
//   },

//   setOptions: function(selector, values) {
//     for (var i = 0, count = values.length; i < values.length; i++) {
//       var opt = document.createElement('option');
//       opt.value = values[i];
//       opt.innerHTML = values[i];
//       selector.appendChild(opt);
//     }
//   }
// };

// Shopify.formatMoney = function(cents, format = "") {
//   if (typeof cents === "string") {
//     cents = cents.replace(".", "");
//   }
//   const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window?.themeVariables?.settings?.moneyFormat;
//   function defaultTo(value2, defaultValue) {
//     return value2 == null || value2 !== value2 ? defaultValue : value2;
//   }
//   function formatWithDelimiters(number, precision, thousands, decimal) {
//     precision = defaultTo(precision, 2);
//     thousands = defaultTo(thousands, ",");
//     decimal = defaultTo(decimal, ".");
//     if (isNaN(number) || number == null) {
//       return 0;
//     }
//     number = (number / 100).toFixed(precision);
//     let parts = number?.split("."), dollarsAmount = parts[0]?.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
//     return dollarsAmount + centsAmount;
//   }
//   let value = "";
//   switch (formatString?.match(placeholderRegex)?.[1]) {
//     case "amount":
//       value = formatWithDelimiters(cents, 2);
//       break;
//     case "amount_no_decimals":
//       value = formatWithDelimiters(cents, 0);
//       break;
//     case "amount_with_space_separator":
//       value = formatWithDelimiters(cents, 2, " ", ".");
//       break;
//     case "amount_with_comma_separator":
//       value = formatWithDelimiters(cents, 2, ".", ",");
//       break;
//     case "amount_with_apostrophe_separator":
//       value = formatWithDelimiters(cents, 2, "'", ".");
//       break;
//     case "amount_no_decimals_with_comma_separator":
//       value = formatWithDelimiters(cents, 0, ",", ".");
//       break;
//     case "amount_no_decimals_with_space_separator":
//       value = formatWithDelimiters(cents, 0, " ");
//       break;
//     case "amount_no_decimals_with_apostrophe_separator":
//       value = formatWithDelimiters(cents, 0, "'");
//       break;
//   }
//   if (formatString.indexOf("with_comma_separator") !== -1) {
//     return formatString.replace(placeholderRegex, value);
//   } else {
//     return formatString.replace(placeholderRegex, value);
//   }
// }

// /*================ Helper Functions ================*/
// function getFocusableElements(container) {
//   return Array.from(
//     container.querySelectorAll(
//       "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
//     )
//   );
// }

// const trapFocusHandlers = {};

// function trapFocus(container, elementToFocus = container) {
//   var elements = getFocusableElements(container);
//   var first = elements[0];
//   var last = elements[elements.length - 1];

//   removeTrapFocus();

//   trapFocusHandlers.focusin = (event) => {
//     if (
//       event.target !== container &&
//       event.target !== last &&
//       event.target !== first
//     )
//       return;

//     document.addEventListener('keydown', trapFocusHandlers.keydown);
//   };

//   trapFocusHandlers.focusout = function() {
//     document.removeEventListener('keydown', trapFocusHandlers.keydown);
//   };

//   trapFocusHandlers.keydown = function(event) {
//     if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
//     // On the last focusable element and tab forward, focus the first element.
//     if (event.target === last && !event.shiftKey) {
//       event.preventDefault();
//       first.focus();
//     }

//     //  On the first focusable element and tab backward, focus the last element.
//     if (
//       (event.target === container || event.target === first) &&
//       event.shiftKey
//     ) {
//       event.preventDefault();
//       last.focus();
//     }
//   };

//   document.addEventListener('focusout', trapFocusHandlers.focusout);
//   document.addEventListener('focusin', trapFocusHandlers.focusin);

//   elementToFocus.focus();
// }

// function removeTrapFocus(elementToFocus = null) {
//   document.removeEventListener('focusin', trapFocusHandlers.focusin);
//   document.removeEventListener('focusout', trapFocusHandlers.focusout);
//   document.removeEventListener('keydown', trapFocusHandlers.keydown);

//   if (elementToFocus) elementToFocus.focus();
// }

// // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
// try {
//   document.querySelector(":focus-visible");
// } catch {
//   focusVisiblePolyfill();
// }

// function focusVisiblePolyfill() {
//   const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
//   let currentFocusedElement = null;
//   let mouseClick = null;

//   window.addEventListener('keydown', (event) => {
//     if(navKeys.includes(event.code.toUpperCase())) {
//       mouseClick = false;
//     }
//   });

//   window.addEventListener('mousedown', (event) => {
//     mouseClick = true;
//   });

//   window.addEventListener('focus', () => {
//     if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

//     if (mouseClick) return;

//     currentFocusedElement = document.activeElement;
//     currentFocusedElement.classList.add('focused');

//   }, true);
// }

// function pauseAllMedia() {
//   document.querySelectorAll('.js-youtube').forEach((video) => {
//     video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
//   });
//   document.querySelectorAll('.js-vimeo').forEach((video) => {
//     video.contentWindow.postMessage('{"method":"pause"}', '*');
//   });
//   document.querySelectorAll('video').forEach((video) => video.pause());
//   document.querySelectorAll('product-model').forEach((model) => {
//     if (model.modelViewerUI) model.modelViewerUI.pause();
//   });
// }

// function debounce(fn, wait) {
//   let t;
//   return (...args) => {
//     clearTimeout(t);
//     t = setTimeout(() => fn.apply(this, args), wait);
//   };
// }

// function fetchConfig(type = 'json') {
//   return {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
//   };
// }

// function getCookie(name) {
//   var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
//   return v ? v[2] : null;
// }

// function setCookie(name, value, days) {
//   var d = new Date;
//   d.setTime(d.getTime() + 24*60*60*1000*days);
//   document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
// }

// function slideUp(target, duration = 500) {
//   target.style.transitionProperty = 'height, margin, padding';
//   target.style.transitionDuration = duration + 'ms';
//   target.style.boxSizing = 'border-box';
//   target.style.height = target.offsetHeight + 'px';
//   target.offsetHeight;
//   target.style.overflow = 'hidden';
//   target.style.height = 0;
//   target.style.paddingTop = 0;
//   target.style.paddingBottom = 0;
//   target.style.marginTop = 0;
//   target.style.marginBottom = 0;
//   window.setTimeout( () => {
//         target.style.display = 'none';
//         target.style.removeProperty('height');
//         target.style.removeProperty('padding-top');
//         target.style.removeProperty('padding-bottom');
//         target.style.removeProperty('margin-top');
//         target.style.removeProperty('margin-bottom');
//         target.style.removeProperty('overflow');
//         target.style.removeProperty('transition-duration');
//         target.style.removeProperty('transition-property');
//         //alert("!");
//   }, duration);
// }

// function slideDown(target, duration = 500) {
//   target.style.removeProperty('display');
//   let display = window.getComputedStyle(target).display;
//   if (display === 'none') display = 'block';
//   target.style.display = display;
//   let height = target.offsetHeight;
//   target.style.overflow = 'hidden';
//   target.style.height = 0;
//   target.style.paddingTop = 0;
//   target.style.paddingBottom = 0;
//   target.style.marginTop = 0;
//   target.style.marginBottom = 0;
//   target.offsetHeight;
//   target.style.boxSizing = 'border-box';
//   target.style.transitionProperty = "height, margin, padding";
//   target.style.transitionDuration = duration + 'ms';
//   target.style.height = height + 'px';
//   target.style.removeProperty('padding-top');
//   target.style.removeProperty('padding-bottom');
//   target.style.removeProperty('margin-top');
//   target.style.removeProperty('margin-bottom');
//   window.setTimeout( () => {
//     target.style.removeProperty('height');
//     target.style.removeProperty('overflow');
//     target.style.removeProperty('transition-duration');
//     target.style.removeProperty('transition-property');
//   }, duration);
// }

// function slideToggle(target, duration = 500) {
//   if (window.getComputedStyle(target).display === 'none') {
//     return slideDown(target, duration);
//   } else {
//     return slideUp(target, duration);
//   }
// }

// function fadeIn(target, duration = 500) {
//   target.style.display = '';
//   target.style.opacity = 0;
//   var last = +new Date();
//   var tick = function() {
//     target.style.opacity = +target.style.opacity + (new Date() - last) / duration;
//     last = +new Date();
//     if (+target.style.opacity < 1) {
//       (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
//     }
//   };
//   tick();
// }

// function fadeOut(target, duration = 500) {
//   target.style.display = '';
//   target.style.opacity = 1;
//   let last = +new Date();
//   let tick = function() {
//     target.style.opacity = Number(+target.style.opacity - (new Date() - last) / duration).toFixed(4);
//     last = +new Date();
//     if (-target.style.opacity <= 0) {
//       (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
//     } else{
//         target.style.opacity = 0;
//     }
//   };
//   tick();
// }

// function getSectionInnerHTML(html, selector) {
//   return new DOMParser()
//     .parseFromString(html, 'text/html')
//     .querySelector(selector).innerHTML;
// }

// function atcGetSectionsToRender() {
//   return [
//     {
//       id: 'cart-drawer__content',
//       section: document.getElementById('cart-drawer__content').dataset.id,
//       selector: '.cart-drawer__content',
//     },
//     {
//       id: 'cart-icon-bubble',
//       section: 'cart-icon-bubble',
//       selector: '.shopify-section'
//     }
//   ];
// }

// function addToCart(body, openCart = true) {
//   fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
//   .then((response) => response.json())
//   .then((parsedState) => {
//     atcGetSectionsToRender().forEach((section => {
//       const elementToReplace =
//         document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

//       elementToReplace.innerHTML =
//         getSectionInnerHTML(parsedState.sections[section.section], section.selector);
//     }));
//   })
//   .catch((e) => {
//     console.error(e);
//   })
//   .finally(() => {
//     if (openCart) {
//       document.querySelector('cart-drawer').open();
//     }
//   });
// }

// const serializeForm = form => {
//   const obj = {},
//         properties = {};
//   const formData = new FormData(form);
//   for (const key of formData.keys()) {
//     if(key.includes("properties")){
//       if(formData.get(key) != '')  properties[key.replace('properties[', "").replace("]", "")] = formData.get(key);
//     }else{
//       obj[key] = formData.get(key); 
//     }
//   }
  
//   if(Object.keys(properties).length > 0 ) obj.properties = properties;

//   return JSON.stringify(obj);
// };

// /*================ Initialize ================*/
// // Micromodal
// MicroModal.init({
//   openClass: 'is-open',
//   disableScroll: true,
//   disableFocus: true,
//   awaitOpenAnimation: true,
//   awaitCloseAnimation: true
// });

// /*================ Components ================*/
// var MenuDrawer = class extends HTMLElement {
//   constructor() {
//     super();

//     this.drawer = this.drawer = document.getElementById('menu-drawer');
//     this.openButtons = document.querySelectorAll('.js-open-menu');
//     this.closeButtons = document.querySelectorAll('.js-close-menu');
//     this.menuButtons = document.querySelectorAll('.menu-drawer__menu-button');
//     this.pageOverlayElement = document.querySelector('.page-overlay');

//     this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeMenuDrawer());
//     this.bindEvents();
//   }

//   bindEvents() {
//     this.openButtons.forEach(openBtn => openBtn.addEventListener('click', this.openMenuDrawer.bind(this)));
//     this.closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeMenuDrawer.bind(this)));
//     this.menuButtons.forEach(menuBtn => menuBtn.addEventListener('click', this.toggleMenuButtons.bind(this)));
//     this.onBodyClick = this.handleBodyClick.bind(this);
//   }

//   openMenuDrawer() {
//     this.drawer.setAttribute('aria-hidden', false);
//     this.drawer.setAttribute('aria-expanded', true);

//     this.pageOverlayElement.classList.add('is-visible');
//     document.body.addEventListener('click', this.onBodyClick);
//   }

//   closeMenuDrawer() {
//     this.drawer.setAttribute('aria-hidden', true);
//     this.drawer.removeAttribute('aria-expanded', true);

//     this.pageOverlayElement.classList.remove('is-visible');
//     document.body.removeEventListener('click', this.onBodyClick);
//   }

//   toggleMenuButtons(event) {  // Pass event explicitly
//     if(!window.location.href?.includes('/collections/')){
//       // event.preventDefault();
//       const parent = event.currentTarget.parentElement;  // Use currentTarget for accuracy
//       const secondaryMenu = event.currentTarget.nextElementSibling;
//       if (!parent || !secondaryMenu) return;  // Safeguard against missing elements
  
//       if (parent.classList.contains('is-open')) {
//         slideUp(secondaryMenu);
//         parent.classList.remove('is-open');
//       } else {
//         slideDown(secondaryMenu);
//         parent.classList.add('is-open');
//       }
//     }
//   }

//   handleBodyClick(evt) {
//     const target = evt.target;
//     if (target.classList.contains('page-overlay')) {
//       this.closeMenuDrawer();
//       this.pageOverlayElement.classList.remove('is-visible');
//     }
//   }
// }

// customElements.define('menu-drawer', MenuDrawer);

// var QuantityInput = class extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input');
//     this.changeEvent = new Event('change', { bubbles: true })

//     this.querySelectorAll('button').forEach(
//       (button) => button.addEventListener('click', this.onButtonClick.bind(this))
//     );
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const previousValue = this.input.value;

//     event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
//     if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
//   }
// }

// customElements.define('quantity-input', QuantityInput);

// window.currentVariantTitle = null;
// window.currentVariant = null;
// window.variantData = null;

// var VariantSelects = class extends HTMLElement {
//   constructor() {
//     super();
//     this.isProductGrid = (this.closest('.product-grid__item') && true) || false;
//     this.addEventListener('change', this.onVariantChange);
//   }

//   connectedCallback() {
//     document.addEventListener('DOMContentLoaded', () => {
//       this.onVariantChange(true);
//     });
//   }


//   onVariantChange(manipulate) {
//     this.updateOptions();
//     this.updateMasterId();
//     this.toggleAddButton(true, '', false);
//     this.updatePickupAvailability();
//     this.removeErrorMessage();

//     if (!this.currentVariant) {
//       this.toggleAddButton(true, '', true);
//       this.setUnavailable();
//       let variantAddVase = this.querySelector('.variant__add_a_vase');
//       if(variantAddVase){
//         let inputNoVase = variantAddVase.querySelector('input[value="No Vase"]');
//         if(!inputNoVase){
//           inputNoVase = this.querySelector('input[value="no vase"]');
//         }
//         if(inputNoVase){
//           inputNoVase.click();
//         }
//       }

//     } else {
//       if(!this.isProductGrid){
//         let dataUrl = this.getAttribute('data-url');
//         if(dataUrl && window.location.href?.includes(dataUrl)) {
//           this.updateMedia();
//           this.updateURL();
//           this.renderProductInfo();
//           let dataManipulate = this.dataset.manipulate;
//           if(manipulate && typeof(manipulate) == 'boolean' && (dataManipulate || dataManipulate == 'true')){
//             let inputRegular = this.querySelector('input[value="Regular"]');
//             if(!inputRegular){
//               inputRegular = this.querySelector('input[value="regular"]');
//             }
//             if(inputRegular){
//               inputRegular.click();
//             }
//           }
//         }else{
//           let closestForm = this.closest('form');
//           if(closestForm){
//             let varInput = closestForm.querySelector('input[name="id"]');
//             if(varInput){
//               varInput.value = this.currentVariant.id;
//             }
//             let submitBtn = closestForm.querySelector('.add__button');
//             if(!this?.currentVariant?.available){
//               if(submitBtn){
//                 submitBtn.setAttribute('disabled', 'disabled');
//                 submitBtn.querySelector('.btn__text').textContent = window.variantStrings.soldOut;
//               }
//             }else{
//               if(submitBtn){
//                 submitBtn.removeAttribute('disabled');
//                 submitBtn.querySelector('.btn__text').textContent = 'ADD';
//               }
//             }
//           }
//         }

//       }else{
//         this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true);
//       }
//       this.updateVariantInput();
//       this.updateShareUrl();
//       this.updateOptionsData();
//     }
//   }

//   updateOptionsData() {
//     // window.currentVariant = this.currentVariant;
//     // let currentVarTitle = this.currentVariant.title;
//     // let thisVal = this;
    
//     let productInfoContainer = document.querySelector(".product__info-container");
//     if(productInfoContainer){
//         let productTitleElement = productInfoContainer.querySelector(".product__title");
//         if(productTitleElement){
//             let productTitle = productTitleElement.textContent?.toLowerCase()?.trim();
//             let currentVariantName = this.currentVariant?.name?.toLowerCase()?.trim();

//             if(currentVariantName?.includes(productTitle)){
//               window.currentVariant = this.currentVariant;
//               let currentVarTitle = this.currentVariant.title;
//               let thisVal = this;
//               let currentVarTitleDowncase = this.currentVariant.title?.toLowerCase();
//               let currentVariant = this.currentVariant;
//               let candiesLimitSpan = document.querySelector(".candies__limit")
//               if(currentVarTitleDowncase?.includes("mini")){
//                 if(currentVarTitleDowncase?.includes("mini")) window.selectionNum = 2;
//                 if(currentVarTitleDowncase?.includes("mini") && candiesLimitSpan) candiesLimitSpan.textContent = 2;
//               }else{
//                 if(currentVarTitleDowncase) window.selectionNum = window.candyLimit ?? 2;
//                 if(candiesLimitSpan) candiesLimitSpan.textContent = window.candyLimit ?? 2;
//               }
              
//               // filter gift slide start
//               let closestForm = thisVal.closest("form");
//               if(closestForm){
//                 let candleProductItem = closestForm.querySelector('.product__item[data-handle*="candle"]');
//                 let pastaNightProductItem = closestForm.querySelector('.product__item[data-handle*="pasta"]');
//                 if(currentVarTitleDowncase?.includes("mini")) {
//                   if(candleProductItem) candleProductItem.style.display = "none";
//                   if(pastaNightProductItem) pastaNightProductItem.style.display = "none";
//                 }else{
//                   if(candleProductItem) candleProductItem.style.display = "block";
//                   if(pastaNightProductItem) pastaNightProductItem.style.display = "block";
//                 }
//               }
          
//               let productInfoWrap = document.querySelectorAll('.product__info--wrap');
//               productInfoWrap.forEach(function (ele) {
//                 ele.classList.remove('gift__product--added');
//               });
//               window.specificUpsellData = null;
//               // filter gift slide end
          
//               if(currentVarTitleDowncase?.includes('vase')){
//                 let variantAddVase = thisVal.querySelector('.variant__add_a_vase');
//                 if(currentVarTitleDowncase?.includes('mini')){
//                   if(variantAddVase){
//                     variantAddVase.classList.add('hidden');
//                   }
//                 }else{
//                   if (variantAddVase && variantAddVase.classList.contains('hidden')) {
//                     variantAddVase.classList.remove('hidden');
//                   }
//                 }
//                 window.currentVariantTitle = currentVarTitle;
//                 window.currentVariant = currentVariant;
//                 let variantScript = document.querySelector('.variant-script');
//                 if(variantScript) {
//                   const jsonData = variantScript.textContent; 
//                   const variantData = JSON.parse(jsonData);
//                   window.variantData = variantData;
//                   let foundVariant = variantData?.find(variant => variant.option1 == currentVariant.option1);
//                   const foundVariants = variantData?.filter(variant => variant.option1 === currentVariant.option1);
//                   if(foundVariants?.length > 0){
//                     foundVariants.forEach(variant => {
//                       if(foundVariant?.price != variant.price){
//                         let option2 = variant.option2;
//                         let selectedInput = document.querySelector(`input[value="${option2}"]`);
//                         if(selectedInput){
//                           let variantLabel = selectedInput.closest('.variant__label');
//                           if(variantLabel){
//                             let errorMsgValidation = document.querySelector(".error-msg-validation");
//                             if(errorMsgValidation){
//                              errorMsgValidation.innerHTML = "";
//                             }
//                             let diffVariantPrice = Number(variant.price) - Number(foundVariant?.price);
//                             let variantPrice = variantLabel.querySelector('.variant__price');
//                             if(variantPrice){
//                               variantPrice.innerHTML = ` ${formatMoney(diffVariantPrice)}`;
//                             }
//                           }
//                         }
                        
//                       }
//                     });
//                   }
//                 }
//               }

//             }
//         }
//     }
    
    

//   }

//   updateOptions() {
//     this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
//   }

//   updateMasterId() {
//     this.currentVariant = this.getVariantData().find((variant) => {
//       return !variant.options.map((option, index) => {
//         return this.options[index] === option;
//       }).includes(false);
//     });
//   }

//   updateMedia() {
//     if (!this.currentVariant) return;
//     if (!this.currentVariant.featured_media) return;
//     const newMedia = document.querySelector(
//       `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
//     );

//     if (!newMedia) return;
//     const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
//     const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
//     const parent = newMedia.parentElement;
//     if (parent.firstChild == newMedia) return;
//     modalContent.prepend(newMediaModal);
//     parent.prepend(newMedia);
//     this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//     if(this.stickyHeader) {
//       this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//     }
//     window.setTimeout(() => {
//       parent.scrollLeft = 0;
//       parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
//     });
//   }

//   updateURL() {
//     if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
//    if(!window.location.href.includes('pages')){
//      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
//    }
//   }

//   updateShareUrl() {
//     const shareButton = document.getElementById(`Share-${this.dataset.section}`);
//     if (!shareButton) return;
//     shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
//   }

//   updateVariantInput() {
//     const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
//     let id = this.currentVariant.id;
//     productForms.forEach((productForm) => {
//       const input = productForm.querySelector('[name="id"]');
//       input.value = this.currentVariant.id;
//       if(productForm.querySelectorAll('.main-id').length){
//          productForm.querySelectorAll('.main-id').forEach(function(elm){
//            elm.value = id;
//          })
//       }
//       input.dispatchEvent(new Event('change', { bubbles: true }));
//     });
//   }

//   updatePickupAvailability() {
//     const pickUpAvailability = document.querySelector('pickup-availability');
//     if (!pickUpAvailability) return;

//     if (this.currentVariant && this.currentVariant.available) {
//       pickUpAvailability.fetchAvailability(this.currentVariant.id);
//     } else {
//       pickUpAvailability.removeAttribute('available');
//       pickUpAvailability.innerHTML = '';
//     }
//   }

//   removeErrorMessage() {
//     const section = this.closest('section');
//     if (!section) return;

//     const productForm = section.querySelector('product-form');
//     if (productForm) productForm.handleErrorMessage();
//   }

//   renderProductInfo() {
//     fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
//       .then((response) => response.text())
//       .then((responseText) => {
//         const id = `price-${this.dataset.section}`;
//         const html = new DOMParser().parseFromString(responseText, 'text/html')
//         const destination = document.getElementById(id);
//         const source = html.getElementById(id);
//         if (source && destination) destination.innerHTML = source.innerHTML;
//         const price = document.getElementById(`price-${this.dataset.section}`);
//         if (price) price.classList.remove('visibility-hidden');
//         this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
//       });
//   }

//   toggleAddButton(disable = true, text, modifyClass = true) {
//     const productForm = document.getElementById(`product-form-${this.dataset.section}`);
//     if (productForm) return;
//     const addButton = productForm.querySelector('[name="add"]');
//     addButton.remove();
//     const addButtonText = productForm.querySelector('[name="add"] > span');

//     if (!addButton) return;

//     if(window.addCandyOnSubmit){
//       window.currentVariantAvailable = this.currentVariant.available;
//       let candySelectionLimit = window.selectionNum ?? 3;
//       let childCustomCandyInputs = productForm.querySelectorAll("input[type='checkbox']:checked");
//       let totalCount = 0;
//       childCustomCandyInputs.forEach(function (element) {
//         let closestProductContent = element.closest(".product__content");
//         if (closestProductContent) {
//           let candyQtySelector = closestProductContent.querySelector(".candy__qty--selector");
//           if (candyQtySelector) {
//             totalCount += Number(candyQtySelector.value);
//           }
//         }
//       });
//       if(totalCount < candySelectionLimit){
//         addButton.setAttribute('disabled', 'disabled');
//         return;
//       }
//     }

//     if (disable) {
//       addButton.setAttribute('disabled', 'disabled');
//       if (text) addButtonText.textContent = text;
//     } else {
//       if(addButton.hasAttribute('collectionSets') == false){
//         addButton.removeAttribute('disabled');
//         addButtonText.textContent = window.variantStrings.addToCart;
//       }
//    }
//     if(this.isProductGrid){
//       let variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent).varaint_prices;
//       if(this.currentVariant){
//         addButton.querySelector('.product__card-price').innerText = variantData[this.currentVariant.id].price;
//       }
//     }
//     if (!modifyClass) return;
//   }

//   setUnavailable() {
//     const button = document.getElementById(`product-form-${this.dataset.section}`);
//     if(button){
//       const addButton = button.querySelector('[name="add"]');
//       const addButtonText = button.querySelector('[name="add"] > span');
//       const price = document.getElementById(`price-${this.dataset.section}`);
//       if (!addButton) return;
//       addButtonText.textContent = window.variantStrings.unavailable;
//       if (price) price.classList.add('visibility-hidden');
//     }
//   }

//   getVariantData() {
//     let variantJson = JSON.parse(this.querySelector('[type="application/json"]').textContent);
//     this.variantData = this.variantData || ((variantJson.variants && variantJson.variants) || variantJson);
//     return this.variantData;
//   }
// }

// customElements.define('variant-selects', VariantSelects);

// var VariantRadios = class extends VariantSelects {
//   constructor() {
//     super();
//   }

//   updateOptions() {
//     const fieldsets = Array.from(this.querySelectorAll('fieldset'));
//     this.options = fieldsets.map((fieldset) => {
//       return Array?.from(fieldset.querySelectorAll('input')).find((radio) => radio?.checked)?.value;
//     });
//   }
// }

// customElements.define('variant-radios', VariantRadios);

// var AddToCart = class extends HTMLElement {
//   constructor() {
//     super();

//     this.button = this.querySelector('button');
//     this.button.addEventListener('click', this.onButtonClick.bind(this));
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const id = this.dataset.id;
//     const body = JSON.stringify({
//       items: [{
//         id: id,
//         quantity: 1
//       }],
//       sections: atcGetSectionsToRender().map((section) => section.section),
//       sections_url: window.location.pathname
//     });

//     addToCart(body);
//   }
// }

// customElements.define('add-to-cart', AddToCart);

/*================ Shopify Common JS ================*/
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  } 
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  if (this.countryEl) {
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

    this.initCountry();
    this.initProvince();
  }
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.formatMoney = function(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window?.themeVariables?.settings?.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number?.split("."), dollarsAmount = parts[0]?.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString?.match(placeholderRegex)?.[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

/*================ Helper Functions ================*/
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function slideUp(target, duration = 500) {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
  }, duration);
}

function slideDown(target, duration = 500) {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

function slideToggle(target, duration = 500) {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

function fadeIn(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 0;
  var last = +new Date();
  var tick = function() {
    target.style.opacity = +target.style.opacity + (new Date() - last) / duration;
    last = +new Date();
    if (+target.style.opacity < 1) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    }
  };
  tick();
}

function fadeOut(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 1;
  let last = +new Date();
  let tick = function() {
    target.style.opacity = Number(+target.style.opacity - (new Date() - last) / duration).toFixed(4);
    last = +new Date();
    if (-target.style.opacity <= 0) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    } else{
        target.style.opacity = 0;
    }
  };
  tick();
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function atcGetSectionsToRender() {
  return [
    {
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }
  ];
}

function addToCart(body, openCart = true) {
  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
  .then((response) => response.json())
  .then((parsedState) => {
    atcGetSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML =
        getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
    if (openCart) {
      document.querySelector('cart-drawer').open();
    }
  });
}

const serializeForm = form => {
  const obj = {},
        properties = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    if(key.includes("properties")){
      if(formData.get(key) != '')  properties[key.replace('properties[', "").replace("]", "")] = formData.get(key);
    }else{
      obj[key] = formData.get(key); 
    }
  }
  
  if(Object.keys(properties).length > 0 ) obj.properties = properties;

  return JSON.stringify(obj);
};

/*================ Initialize ================*/
// Micromodal
MicroModal.init({
  openClass: 'is-open',
  disableScroll: true,
  disableFocus: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true
});

/*================ Components ================*/
var MenuDrawer = class extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.drawer = document.getElementById('menu-drawer');
    this.openButtons = document.querySelectorAll('.js-open-menu');
    this.closeButtons = document.querySelectorAll('.js-close-menu');
    this.menuButtons = document.querySelectorAll('.menu-drawer__menu-button');
    this.pageOverlayElement = document.querySelector('.page-overlay');

    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeMenuDrawer());
    this.bindEvents();
  }

  bindEvents() {
    this.openButtons.forEach(openBtn => openBtn.addEventListener('click', this.openMenuDrawer.bind(this)));
    this.closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeMenuDrawer.bind(this)));
    this.menuButtons.forEach(menuBtn => menuBtn.addEventListener('click', this.toggleMenuButtons.bind(this)));
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  openMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.add('is-visible');
    document.body.addEventListener('click', this.onBodyClick);
  }

  closeMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.remove('is-visible');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  toggleMenuButtons(event) {  // Pass event explicitly
    if(!window.location.href?.includes('/collections/')){
      // event.preventDefault();
      const parent = event.currentTarget.parentElement;  // Use currentTarget for accuracy
      const secondaryMenu = event.currentTarget.nextElementSibling;
      if (!parent || !secondaryMenu) return;  // Safeguard against missing elements
  
      if (parent.classList.contains('is-open')) {
        slideUp(secondaryMenu);
        parent.classList.remove('is-open');
      } else {
        slideDown(secondaryMenu);
        parent.classList.add('is-open');
      }
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.closeMenuDrawer();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

var QuantityInput = class extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

window.currentVariantTitle = null;
window.currentVariant = null;
window.variantData = null;

var VariantSelects = class extends HTMLElement {
  constructor() {
    super();
    this.isProductGrid = (this.closest('.product-grid__item') && true) || false;
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      this.onVariantChange(true);
    });
  }


  onVariantChange(manipulate) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      let variantAddVase = this.querySelector('.variant__add_a_vase');
      if(variantAddVase){
        let inputNoVase = variantAddVase.querySelector('input[value="No Vase"]');
        if(!inputNoVase){
          inputNoVase = this.querySelector('input[value="no vase"]');
        }
        if(inputNoVase){
          inputNoVase.click();
        }
      }

    } else {
      if(!this.isProductGrid){
        let dataUrl = this.getAttribute('data-url');
        if(dataUrl && window.location.href?.includes(dataUrl)) {
          this.updateMedia();
          this.updateURL();
          this.renderProductInfo();
          let dataManipulate = this.dataset.manipulate;
          if(manipulate && typeof(manipulate) == 'boolean' && (dataManipulate || dataManipulate == 'true')){
            let inputRegular = this.querySelector('input[value="Regular"]');
            if(!inputRegular){
              inputRegular = this.querySelector('input[value="regular"]');
            }
            if(inputRegular){
              inputRegular.click();
            }
          }
        }else{
          let closestForm = this.closest('form');
          if(closestForm){
            let varInput = closestForm.querySelector('input[name="id"]');
            if(varInput){
              varInput.value = this.currentVariant.id;
            }
            let submitBtn = closestForm.querySelector('.add__button');
            if(!this?.currentVariant?.available){
              if(submitBtn){
                submitBtn.setAttribute('disabled', 'disabled');
                submitBtn.querySelector('.btn__text').textContent = window.variantStrings.soldOut;
              }
            }else{
              if(submitBtn){
                submitBtn.removeAttribute('disabled');
                submitBtn.querySelector('.btn__text').textContent = 'ADD';
              }
            }
          }
        }

      }else{
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true);
      }
      this.updateVariantInput();
      this.updateShareUrl();
      this.updateOptionsData();
    }
  }

  updateOptionsData() {
    // window.currentVariant = this.currentVariant;
    // let currentVarTitle = this.currentVariant.title;
    // let thisVal = this;
    
    let productInfoContainer = document.querySelector(".product__info-container");
    if(productInfoContainer){
        let productTitleElement = productInfoContainer.querySelector(".product__title");
        if(productTitleElement){
            let productTitle = productTitleElement.textContent?.toLowerCase()?.trim();
            let currentVariantName = this.currentVariant?.name?.toLowerCase()?.trim();

            if(currentVariantName?.includes(productTitle)){
              window.currentVariant = this.currentVariant;
              let currentVarTitle = this.currentVariant.title;
              let thisVal = this;
              let currentVarTitleDowncase = this.currentVariant.title?.toLowerCase();
              let currentVariant = this.currentVariant;
              let candiesLimitSpan = document.querySelector(".candies__limit")
              if(currentVarTitleDowncase?.includes("mini")){
                if(currentVarTitleDowncase?.includes("mini")) window.selectionNum = 2;
                if(currentVarTitleDowncase?.includes("mini") && candiesLimitSpan) candiesLimitSpan.textContent = 2;
              }else{
                if(currentVarTitleDowncase) window.selectionNum = window.candyLimit ?? 2;
                if(candiesLimitSpan) candiesLimitSpan.textContent = window.candyLimit ?? 2;
              }
              
              // filter gift slide start
              let closestForm = thisVal.closest("form");
              if(closestForm){
                let candleProductItem = closestForm.querySelector('.product__item[data-handle*="candle"]');
                let pastaNightProductItem = closestForm.querySelector('.product__item[data-handle*="pasta"]');
                if(currentVarTitleDowncase?.includes("mini")) {
                  if(candleProductItem) candleProductItem.style.display = "none";
                  if(pastaNightProductItem) pastaNightProductItem.style.display = "none";
                }else{
                  if(candleProductItem) candleProductItem.style.display = "block";
                  if(pastaNightProductItem) pastaNightProductItem.style.display = "block";
                }
              }
          
              let productInfoWrap = document.querySelectorAll('.product__info--wrap');
              productInfoWrap.forEach(function (ele) {
                ele.classList.remove('gift__product--added');
              });
              window.specificUpsellData = null;
              // filter gift slide end
          
              if(currentVarTitleDowncase?.includes('vase')){
                let variantAddVase = thisVal.querySelector('.variant__add_a_vase');
                if(currentVarTitleDowncase?.includes('mini')){
                  if(variantAddVase){
                    variantAddVase.classList.add('hidden');
                  }
                }else{
                  if (variantAddVase && variantAddVase.classList.contains('hidden')) {
                    variantAddVase.classList.remove('hidden');
                  }
                }
                window.currentVariantTitle = currentVarTitle;
                window.currentVariant = currentVariant;
                let variantScript = document.querySelector('.variant-script');
                if(variantScript) {
                  const jsonData = variantScript.textContent; 
                  const variantData = JSON.parse(jsonData);
                  window.variantData = variantData;
                  let foundVariant = variantData?.find(variant => variant.option1 == currentVariant.option1);
                  const foundVariants = variantData?.filter(variant => variant.option1 === currentVariant.option1);
                  if(foundVariants?.length > 0){
                    foundVariants.forEach(variant => {
                      if(foundVariant?.price != variant.price){
                        let option2 = variant.option2;
                        let selectedInput = document.querySelector(`input[value="${option2}"]`);
                        if(selectedInput){
                          let variantLabel = selectedInput.closest('.variant__label');
                          if(variantLabel){
                            let errorMsgValidation = document.querySelector(".error-msg-validation");
                            if(errorMsgValidation){
                             errorMsgValidation.innerHTML = "";
                            }
                            let diffVariantPrice = Number(variant.price) - Number(foundVariant?.price);
                            let variantPrice = variantLabel.querySelector('.variant__price');
                            if(variantPrice){
                              variantPrice.innerHTML = ` ${formatMoney(diffVariantPrice)}`;
                            }
                          }
                        }
                        
                      }
                    });
                  }
                }
              }

            }
        }
    }
    
    

  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
   if(!window.location.href.includes('pages')){
     window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
   }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    let id = this.currentVariant.id;
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('[name="id"]');
      input.value = this.currentVariant.id;
      if(productForm.querySelectorAll('.main-id').length){
         productForm.querySelectorAll('.main-id').forEach(function(elm){
           elm.value = id;
         })
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = addButton?.querySelector('span');

    if (!addButton) return;

    if(window.addCandyOnSubmit){
      window.currentVariantAvailable = this.currentVariant.available;
      let candySelectionLimit = window.selectionNum ?? 3;
      let childCustomCandyInputs = productForm.querySelectorAll("input[type='checkbox']:checked");
      let totalCount = 0;
      childCustomCandyInputs.forEach(function (element) {
        let closestProductContent = element.closest(".product__content");
        if (closestProductContent) {
          let candyQtySelector = closestProductContent.querySelector(".candy__qty--selector");
          if (candyQtySelector) {
            totalCount += Number(candyQtySelector.value);
          }
        }
      });
      if(totalCount < candySelectionLimit){
        addButton.setAttribute('disabled', 'disabled');
        return;
      }
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      if(addButton.hasAttribute('collectionSets') == false){
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
   }
    if(this.isProductGrid){
      let variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent).varaint_prices;
      if(this.currentVariant){
        addButton.querySelector('.product__card-price').innerText = variantData[this.currentVariant.id].price;
      }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if(button){
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    }
  }

  getVariantData() {
    let variantJson = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.variantData = this.variantData || ((variantJson.variants && variantJson.variants) || variantJson);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

var VariantRadios = class extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array?.from(fieldset.querySelectorAll('input')).find((radio) => radio?.checked)?.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

var AddToCart = class extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const id = this.dataset.id;
    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    addToCart(body);
  }
}

customElements.define('add-to-cart', AddToCart);

